import { type IntlCache } from 'react-intl';
import { newIntl as newIntlCommon } from '@empathco/ui-components/src/common/intl';
// local imports
import en from '../locales/en.json';

export const newIntl = (
  customMessages?: Record<string, string>,
  customCache?: IntlCache
) => newIntlCommon(en, customMessages, customCache);
